"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var View_1 = require("../../View");
var helpers_1 = require("./helpers");
var Root = styled_components_1.default(View_1.View)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    position: relative;\n    height: 100%;\n    flex: 1;\n    overflow: auto;\n    padding-left: ", ";\n    padding-right: ", ";\n"], ["\n    position: relative;\n    height: 100%;\n    flex: 1;\n    overflow: auto;\n    padding-left: ", ";\n    padding-right: ", ";\n"])), helpers_1.config.paddingLeft, helpers_1.config.paddingRight);
var Inner = styled_components_1.default(View_1.View)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    ", "\n"], ["\n    ",
    "\n"])), function (_a) {
    var width = _a.width, fullWidth = _a.fullWidth;
    return !fullWidth &&
        width !== '100%' && styled_components_1.css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n            max-width: ", ";\n        "], ["\n            max-width: ", ";\n        "])), width);
});
exports.PageWizardBody = function (_a) {
    var children = _a.children, _b = _a.fullWidthContent, fullWidthContent = _b === void 0 ? false : _b, widthContent = _a.widthContent, rest = __rest(_a, ["children", "fullWidthContent", "widthContent"]);
    return (react_1.default.createElement(Root, { contentMod: View_1.VIEW_CONTENT_MOD.fill, clipped: true, spaceVertical: View_1.INDENT.m, testId: rest['data-selector-id'] || 'pagewizard-wizardbody' },
        react_1.default.createElement(Inner, { fullWidth: fullWidthContent, width: widthContent }, children)));
};
exports.PageWizardBody.displayName = 'PageWizardBody';
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=PageWizardBody.js.map